import { createSlice } from '@reduxjs/toolkit';
import { ICountryInfo } from '../../interface/storeInterface';
import { CountryWithStateList } from '../../data/country';

const initialState: ICountryInfo = {
  countriesList: CountryWithStateList,
};

const CountryInfoSlice = createSlice({
  name: 'CountryInfo',
  initialState,
  reducers: {
    setCountriesList: (state, action) => {
      state.countriesList = action?.payload;
    },
  },
});

export const { setCountriesList } = CountryInfoSlice.actions;

export default CountryInfoSlice.reducer;
